import React from 'react'
import { Link } from 'react-router-dom'

import { getAllNotifications } from 'src/axious/notifications'

import Icon from '../../../ui/Icon/Icon'
import styles from './Bell.module.scss'

const Bell = () => {
  const [isNewNotifications, setIsNewNotifications] = React.useState<boolean>(false)
  const notificationsLength = localStorage.getItem('notifications_length')

  if (!notificationsLength) {
    localStorage.setItem('notifications_length', '0')
  }

  React.useEffect(() => {
    getAllNotifications()
      .then((data) => {
        if (data.length > Number(notificationsLength)) {
          setIsNewNotifications(true)
        }
      })
      .catch((err) => console.log('err:', err))
  }, [notificationsLength])

  return (
    <Link to='/notifications' className={styles.bell}>
      <Icon name='bell' />

      {isNewNotifications && <div className={styles.bell_messages} />}
    </Link>
  )
}

export default Bell
